import { SeriesCard as BaseSeriesCard } from './series-card'
import { SeriesCardActive, SeriesCardActiveProps } from './series-card-active'
import { SeriesCardBadgeInProgress } from './series-card-badge-in-progress'
import { SeriesCardContent } from './series-card-content'
import { SeriesCardDefault } from './series-card-default'
import { SeriesCardImage } from './series-card-image'
import { SeriesCardIntensityBadge } from './series-card-intensity-badge'
import { SeriesCardKeepGoing, SeriesCardKeepGoingProps } from './series-card-keep-going'
import { SeriesCardMeta } from './series-card-meta'
import { SeriesCardMetaActive } from './series-card-meta-active'
import { SeriesCardDismissSeriesButton } from './series-card-dismiss-series-button'
import { SeriesCardOverlay } from './series-card-overlay'
import { SeriesCardProgress } from './series-card-progress'
import { SeriesCardSkeleton, SeriesCardKeepGoingSkeleton } from './series-card-skeleton'
import { SeriesCardTitle } from './series-card-title'
import { SeriesCardWithCancelDialog } from './series-card-with-cancel-dialog'
import type { Programme } from '../../../dao/core-dao'
import React, { type ComponentType, type MouseEvent, type ReactNode } from 'react'

// Compose compound components
const SeriesCard = BaseSeriesCard as typeof BaseSeriesCard & {
  Image: ComponentType<{ children?: ReactNode; className?: string }>
  Overlay: ComponentType<{ children: ReactNode; className?: string }>
  Content: ComponentType<{ children: ReactNode; className?: string }>
  IntensityBadge: ComponentType<{ className?: string }>
  Title: ComponentType<{ className?: string }>
  Meta: ComponentType<{ className?: string }>
  MetaActive: ComponentType<{ className?: string }>
  BadgeInProgress: ComponentType<{ className?: string }>
  Progress: ComponentType<{
    completedCount: number | undefined
    totalCount: number | undefined
    isReady: boolean
    className?: string
  }>
  Options: ComponentType<{ onCancelSeriesClick: () => void; className?: string }>
  Default: ComponentType<{
    series: Programme
    className?: string
    onAction?: () => void
    withDismissControl?: boolean
    onDismissControlClick?: (e: MouseEvent<HTMLButtonElement>) => void
  }>
  Active: ComponentType<SeriesCardActiveProps>
  KeepGoing: ComponentType<SeriesCardKeepGoingProps>
}

SeriesCard.Image = SeriesCardImage
SeriesCard.Overlay = SeriesCardOverlay
SeriesCard.Content = SeriesCardContent
SeriesCard.IntensityBadge = SeriesCardIntensityBadge
SeriesCard.Title = SeriesCardTitle
SeriesCard.Meta = SeriesCardMeta
SeriesCard.MetaActive = SeriesCardMetaActive
SeriesCard.BadgeInProgress = SeriesCardBadgeInProgress
SeriesCard.Progress = SeriesCardProgress
SeriesCard.Options = (({ onCancelSeriesClick, className }: { onCancelSeriesClick: () => void; className?: string }) =>
  React.createElement(SeriesCardDismissSeriesButton, {
    'data-testid': 'series-card-dismiss-series',
    onDismissClick: () => onCancelSeriesClick(),
    className,
  })) as ComponentType<{ onCancelSeriesClick: () => void; className?: string }>
SeriesCard.Default = SeriesCardDefault
SeriesCard.Active = SeriesCardActive
SeriesCard.KeepGoing = SeriesCardKeepGoing

export { SeriesCard }
export { SeriesCardActive, SeriesCardDismissSeriesButton, SeriesCardKeepGoing, SeriesCardSkeleton, SeriesCardKeepGoingSkeleton }
export { SeriesCardWithCancelDialog }
export type { SeriesCardActiveProps, SeriesCardKeepGoingProps }
export type { Programme } from 'src/dao/core-dao'
